var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent } from 'react';
import { uniqueId } from 'lodash-es';
import { Databus } from '@portals/databus';
import { mapperValues } from '../utils/mapped-values';
export var subscriber = function (_a) {
    var getStateToProps = _a.getStateToProps;
    return function (WrappedComponent) {
        return /** @class */ (function (_super) {
            __extends(class_1, _super);
            function class_1(props) {
                var _this = _super.call(this, props) || this;
                _this.state = Object.keys(getStateToProps).reduce(function (accum, name) {
                    var _a;
                    var currentPropValues = getStateToProps[name];
                    var databus = new Databus({ name: name });
                    var eventId = uniqueId(name + "__");
                    databus.addEvent({ eventId: eventId });
                    databus.addEventListener({
                        eventId: eventId,
                        listener: function () {
                            return _this.setState(function (prevState) { return (__assign(__assign({}, prevState), mapperValues(currentPropValues, name))); });
                        },
                    });
                    return __assign(__assign(__assign({}, accum), mapperValues(currentPropValues, name)), { eventsMeta: __assign(__assign({}, accum.eventsMeta), (_a = {}, _a[name] = eventId, _a)) });
                }, {
                    eventsMeta: {},
                });
                return _this;
            }
            class_1.prototype.componentWillUnmount = function () {
                for (var eventName in this.state.eventsMeta) {
                    new Databus({ name: eventName }).removeEventListener({
                        eventId: this.state.eventsMeta[eventName],
                    });
                }
            };
            class_1.prototype.render = function () {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                var _a = this.state, eventsMeta = _a.eventsMeta, rest = __rest(_a, ["eventsMeta"]);
                return React.createElement(WrappedComponent, __assign({}, this.props, rest));
            };
            return class_1;
        }(PureComponent));
    };
};
